import { styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { DARK_BORDER, LIGHT_BORDER, LIGHT_CONTAINER_FIELDS_ON_CARD, DARK_CONTAINER_FIELDS_ON_CARD } = COLORS;

export const ListContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 10,
  justifyContent: 'center',
  borderRadius: 5,
  width: '100%',
}));

export const ItemContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  border: theme.palette.type === 'dark' ? `1px solid ${DARK_BORDER}` : `1px solid ${LIGHT_BORDER}`,
  borderRadius: 5,
  width: '100%',
  cursor: 'pointer',
  [theme.breakpoints.down(1000)]: {
    flexDirection: 'column',
    alignItems: 'unset',

    '& > div:not(:first-child)': {
      alignItems: 'unset',

      '& * p': {
        lineHeight: '1.4!important',
      },
    },
  },
}));

export const Left = styled('div')(({ theme }) => ({
  // Background of Due Time
  background: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_ON_CARD : LIGHT_CONTAINER_FIELDS_ON_CARD,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  padding: '15px 30px',
  borderTopLeftRadius: 5,
  borderBottomLeftRadius: 5,

  [theme.breakpoints.down(1000)]: {
    borderRight: 'none',
  },

  '& svg': {
    height: 20,
    width: 'auto',
  },

  '& > div > p': {
    lineHeight: 1.2,
  },
}));

export const Middle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '15px 30px',

  '& > div:first-child': {
    width: 250,
  },

  [theme.breakpoints.down(1000)]: {
    justifyContent: 'space-between',

    '& > div:first-child': {
      width: 'unset',
    },

    '& > div:last-child': {
      textAlign: 'right',
    },
  },

  '& > div > p': {
    lineHeight: 1.2,
  },
}));

export const CustomImage = styled('img')(({ theme }) => ({
  height: 44,
  width: 44,
  borderRadius: 5,
}));

export const Right = styled('div')(({ theme }) => ({
  display: 'flex',
}));

export const CustomIconButton = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: 'auto',
  marginRight: 20,

  '& .MuiSvgIcon-root': {
    width: 14,
    height: 14,
  },
}));
